"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiveawayTimer = void 0;
const useGiveawayTimer_1 = require("root/src/client/web/giveaway/features/GiveawaySection/hooks/useGiveawayTimer");
const PickingWinner_1 = require("root/src/client/web/giveaway/features/GiveawaySection/PickingWinner");
const GiveawayTimer = () => {
    const { classes, formattedISOTimeLeft, isPickingWinner } = (0, useGiveawayTimer_1.useGiveawayTimer)();
    if (isPickingWinner) {
        return <PickingWinner_1.PickingWinner />;
    }
    return (<div className={classes.activeGiveawayInfo}>
			<span className={classes.timeRemainingLabel}>Giveaway time remaining</span>
			<span className={classes.timeRemaining}>{formattedISOTimeLeft}</span>
		</div>);
};
exports.GiveawayTimer = GiveawayTimer;
